import { render, staticRenderFns } from "./OutboundPlanView.vue?vue&type=template&id=2dfc336e&scoped=true"
import script from "./OutboundPlanView.vue?vue&type=script&lang=js"
export * from "./OutboundPlanView.vue?vue&type=script&lang=js"
import style0 from "./OutboundPlanView.vue?vue&type=style&index=0&id=2dfc336e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfc336e",
  null
  
)

export default component.exports